export default __webpack_public_path__ + "static/media/work3.2e03a1cc.png";